import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import { SiteFooter } from '../components/SiteFooter';
import { BrandLogo } from '../components/icons';

export function AuthLayout() {
  return (
    <Shell>
      <Container>
        <AuthBox>
          <Brand>
            <LogoWrap>
              <BrandLogo size={40} />
            </LogoWrap>
            <div>
              <BrandTitle>Auto Threads</BrandTitle>
              <BrandSubtitle>아이디어부터 발행까지, 한곳에서</BrandSubtitle>
            </div>
          </Brand>
          <Outlet />
        </AuthBox>
      </Container>
      <SiteFooter $compact />
    </Shell>
  );
}

const Shell = styled.div`
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  background:
    radial-gradient(
      900px 480px at 50% -10%,
      ${({ theme }) => theme.colors.accentGlow} 0%,
      transparent 55%
    ),
    ${({ theme }) => theme.colors.background};
`;

const Container = styled.main`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 56px 24px;

  @media (max-width: 600px) { padding: 32px 16px; }
`;

const AuthBox = styled.section`
  width: 100%;
  max-width: 460px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  animation: slideUp 0.45s ease both;

  > section {
    padding: 32px;
    box-shadow: ${({ theme }) => theme.shadow.md};
    @media (max-width: 600px) { padding: 28px 20px; }
  }
`;

const Brand = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  justify-content: center;
`;

const LogoWrap = styled.div`
  width: 52px;
  height: 52px;
  border-radius: ${({ theme }) => theme.radius.lg};
  display: grid;
  place-items: center;
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  box-shadow: ${({ theme }) => theme.shadow.md};
`;

const BrandTitle = styled.p`
  font-size: 24px;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

const BrandSubtitle = styled.p`
  margin-top: 2px;
  font-size: 13px;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  color: ${({ theme }) => theme.colors.textSecondary};
`;
